import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-stem',
  imports: [PillarPagesTemp],
  templateUrl: './stem.html',
  styleUrl: './stem.scss',
})
export class Stem {

}
